import { useLoginUserStore } from '@Models/useLoginUserModel';
import style from '@Report/OneTimeReports/index.module.less';
import {
  Box,
  Input,
  Text,
  TextLabel,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOneTimeReportStore } from '../../store';

const ReportName = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const loginUserModel = useLoginUserStore();

  //getter
  const name = useOneTimeReportStore((store) => store.generalSetting.name);

  //setter
  const setName = useOneTimeReportStore((store) => store.setName);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const cb = () => {
      setName(
        (loginUserModel.user?.accountName || '') +
          t('reportCommon.placeholders.defaultOnetimeName')
      );
    };
    cb();

    register(cb);
    return () => unregister(cb);
  }, [loginUserModel]);

  return (
    <>
      <TextLabel className={style.itemLabel + ' required'}>
        {t('reportCommon.labels.name')}:
      </TextLabel>
      <Box>
        <Input
          id="reportName"
          type="text"
          placeholder={t('reportCommon.placeholders.name')}
          value={name}
          onChange={(e: any) => setName(e.target.value)}
          error={name === ''}
          maxLength={200}
          width={450}
        />
        {name === '' && (
          <Text
            fontSize="sm"
            lineHeight="sm"
            color={colorStyle.color.error}
            textAlign="left"
          >
            {t('reportCommon.tips.errors.requiredField')}
          </Text>
        )}
      </Box>
    </>
  );
};

export default ReportName;
